export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    entityDetails: null,
    appProfile: null,
    appProfileDetails: null,
    sector: null,
    sectorDetail: null,
    environment: null,
    envShortName: null,
    region: null,
    regionDetail: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,

    appTier: null,
    appTierCode: null,

    // Existing Exadata Resources
    exadataInfrastructureName: null,
    cloudVmClusterName: null,
    resourceGroup: null,

    // Oracle Database
    databaseName: null,
    databaseUniqueName: null,
    databaseArchitecture: 'NON_CDB',
    databaseVersion: null,
    sgaSize: null,
    pgaSize: null,
    databaseCharacterset: null,
    nationCharacterset: null,

    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    validationStatus: null,
    isTouched: null,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
};

const mapCatalogConfigToOrder = (entityDetails, catalogConfig) => ({
    entityDetails: {
        ...entityDetails,
    },
    appProfile: entityDetails?.name,
    ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
    sector: catalogConfig?.sector || null,
    environment: catalogConfig?.environmentDetails?.environment || null,
    envShortName: catalogConfig?.environmentDetails?.envShortName || null,
    hCode: catalogConfig?.costCenter || null,
    ...(catalogConfig?.costCenter && { hCodeDetails: { label: catalogConfig?.costCenter, value: catalogConfig?.costCenter } }),
    appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
    appOwnerDetails: {
        label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        gpid: entityDetails?.applicationManagerGpid,
        name: entityDetails?.applicationManager,
        email: entityDetails?.applicationManagerEmail,
    },

    appTier: catalogConfig?.environmentDetails?.applicationTier || null,
    appTierCode: catalogConfig?.environmentDetails?.appTierCode || null,

    exadataInfrastructureName: catalogConfig?.exadataInfrastructureName,
    cloudVmClusterName: catalogConfig?.cloudVmClusterName,
    resourceGroup: catalogConfig?.resourceGroup,
    region: catalogConfig?.region,
    ocpuCount: catalogConfig?.ocpuCount,

    databaseName: catalogConfig?.oracleDatabaseName,
    databaseUniqueName: catalogConfig?.databaseUniqueName,
    databaseArchitecture: catalogConfig?.databaseArchitecture || 'NON_CDB',
    databaseVersion: catalogConfig?.version,
    sgaSize: catalogConfig?.sgaSizeInGb,
    pgaSize: catalogConfig?.pgaSizeInGb,
    databaseCharacterset: catalogConfig?.databaseCharacterSet,
    nationCharacterset: catalogConfig?.nationalCharacterSet,
    enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,

    validationStatus: 'clearValidation',
    isTouched: false,
});

export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    return {
        ...mapCatalogConfigToOrder(entityDetails, catalogConfig),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    return {
        ...mapCatalogConfigToOrder(entityDetails, catalogConfig),
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
    };
};
